"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Logo = void 0;
const react_1 = __importDefault(require("react"));
const theme_1 = require("../utils/theme");
const SocialLogin_1 = require("./SocialLogin");
const css_manager_1 = require("@food/css-manager");
const logoDimension = (0, css_manager_1.registerClass)(() => `
	width: 90%;
	max-height: 20vmax;
`);
const style = (0, css_manager_1.registerClass)(() => `
	display: flex;
	align-items: center;
	justify-content: center;
`);
const Logo = ({ custom, layout }) => (react_1.default.createElement("div", { className: (0, css_manager_1.classNames)(style, !custom && 'logo') }, custom && (react_1.default.createElement("img", { src: custom, alt: 'Food auth', className: (0, css_manager_1.classNames)(theme_1.logoImg, layout === SocialLogin_1.SOCIAL_LOGIN_LAYOUTS.STANDARD && logoDimension) }))));
exports.Logo = Logo;
//# sourceMappingURL=Logo.js.map